var addressFinderMultipleInit = function () {
    $('[data-id="address-finder-multi-postcode-search-submit"]').each(function () {
        new MultiAddressFinder($(this)).init();
    });
};

(function ($) {
    var MultiAddressFinder = window.MultiAddressFinder = function (submitButton) {
        var _self = this,
            guid = submitButton.attr("data-container-guid"),
            addressResults = $("[id='searchresults_" + guid + "']"),
            addressOptions = $("[data-guid='addressoptions_" + guid + "']"),
            addressOptionsTitle = $("[data-guid='addressoptionstitle_" + guid + "']"),
            selectedAddressContainer = $("#selected-addresses-container"),
            selectedAddressContainerTitle = $("#selected-addresses-container__title"),
            selectedAddress = $("[id='selectedaddress_" + guid + "']"),
            editSelectedAddress = $("[id='selectedaddress_" + guid + "'] a[data-id='editAddress']"),
            deleteSelectedAddress = $("[id='selectedaddress_" + guid + "'] a[data-id='removeAddress']"),
            postcodeSearch = $("[id='search_" + guid + "']"),
            postcodeInput = submitButton.prev('input'),
            showManualForm = $("[id='showmanualform_" + guid + "']"),
            manualFormLocator = $("[id='manualentry_" + guid + "']"),
            manualPostcodeInput = manualFormLocator.find('[data-id=address-postcode]'),
            noResultsLocator = $("[id='searchnoresults_" + guid + "']"),
            hr = $("[id='hr_" + guid + "']"),
            removeButton = submitButton.siblings("[data-id=removeAddressButton]"),
            uprnInput = manualFormLocator.find('[data-id=address-uprn]'),
            selectedUprns = $("[data-id='selectedAddresses_uprn']"),
            abiyanRemoveAddress = $("[data-id='abiyan_removeAddress']"),
            vb = removeButton;
        var addEvents = function () {
            //attach event handler with remove button
            if (islington.checkValidity(removeButton)) {
                removeAddressInit(removeButton);
                removeAddressInit(deleteSelectedAddress);
            }

            // resolves the issue when enter button is pressed
            postcodeInput.
                off('keypress').
                on('keypress', function (e) {
                    if (e.which == 13)//enter pressed
                    {
                        submitButton.trigger("click");
                        return false;
                    }
                });

            abiyanRemoveAddress.off().on('click', function () {
                var selectedAddress = $(this).parent();
                selectedAddress.remove();
                return false;
            });

            submitButton.
                off('click').
                on('click', function (evt) {

                    evt.preventDefault();
                    selectedAddress.html('');

                    var isValid = $(this).parents("form").data('validator').element("[data-id='postcodefield_" + guid + "']");

                    //manualFormLocator.addClass("x");
                    if (isValid) {
                        addressOptions.empty();
                        var postcode = submitButton.parent().find("input[type='text']").val();

                        $.post('/gis/findaddresses?postcode=' + postcode + '&addEmptyRow=false')
                            .done(function (data) {
                                showAddressResults(data);
                            })
                            .fail(function (data) {
                                showAddressResults(data);
                            });
                    }
                });

            //addressOptions.off('click').on('click', function () {
            //    var selectedAddress = $(this).val();
            //    if (selectedAddress) {
            //        console.log(selectedAddress);
            //        var addressData = JSON.parse($(this).val());
            //        var addressParent = $(this).parents("li");
            //        updateFurnitureWithSelectedAddress(addressData, addressParent);
            //        return false;
            //    }
            //});    

            addressOptions.off('change').on('change', function () {

                var isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;
                if (isTouchScreen === true) {
                    $('div.m-confirmation-single').remove();
                };

                var selectedAddress = $(this).val();
                if (selectedAddress) {
                    console.log(selectedAddress);

                    $.each(selectedAddress, function (index, value) {
                        console.log(value);
                        var addressData = JSON.parse(value);
                        //var addressParent = value.parents("li");
                        updateFurnitureWithSelectedAddress(addressData, );
                        //return false;
                    });

                }
            });

            addressOptions.off('keypress').on('keypress', function (e) {
                if (e.which == 13)//enter pressed                
                {
                    var selectedAddress = $(this).val();
                    if (selectedAddress) {
                        var addressData = JSON.parse($(this).val());
                        var addressParent = $(this).parents("li");
                        updateFurnitureWithSelectedAddress(addressData, addressParent);
                        return false;
                    }
                }

            });

        };

        var updateFurnitureWithSelectedAddress = function (addressData) {
            hideManualEntryForm();
            showField(selectedAddressContainer);

            var addressToShow = appendAddressFieldIfSet(addressData.Line1)
                + appendAddressFieldIfSet(addressData.Line2)
                + appendAddressFieldIfSet(addressData.Line3)
                + appendAddressFieldIfSet(addressData.City)
                + appendAddressFieldIfSet(addressData.Postcode.toUpperCase())
                + appendAddressFieldIfSet(addressData.RateableValue);
            addressData.Line1 = addressData.Line1.replace("'", "");
            addressData.Line2 = addressData.Line2.replace("'", "");
            addressData.Line3 = addressData.Line3.replace("'", "");
            addressData.City = addressData.City.replace("'", "");
            selectedAddress.append(
                "<div class='m-confirmation-single' data-id='" + addressData.Uprn + "'><a href='#' data-id='abiyan_removeAddress' data-remove-guid='" + addressData.Uprn + "' aria-describedby='" + addressData.Uprn + "'>Remove</a><p id='" + addressData.Uprn + "'>"
                + addressToShow
                + "</p><input type='hidden' name='multipleAddressSelection' value='" + JSON.stringify(addressData) + "' /></div>");

            selectedAddressContainerTitle.text(getTitleText(selectedAddress.children().length));

            islington.giveScreenreaderAlert('Address has been added', 'sr-address');
            islington.clearScreenreaderAlert('sr-address');


            var isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;
            if (isTouchScreen === true) {
                $('[data-id=abiyan_removeAddress]').remove();
            };
            

            $("[data-id='abiyan_removeAddress']").on('click', function () {
                $(this).parent().remove();

                islington.giveScreenreaderAlert('Address has been removed', 'sr-address');
                islington.clearScreenreaderAlert('sr-address');


                const addressLength = selectedAddress.children().length;
                if (addressLength === 0) {
                    hideField(selectedAddressContainer);
                }
                selectedAddressContainerTitle.text(getTitleText(selectedAddress.children().length));
                return false;
            });

        };

        var showAddressResults = function (addressData) {
            showField(addressResults);
            if (addressData) {
                addressOptions.append(addressData).focus();
                showField(addressOptions);
                showField(addressOptionsTitle);
                hideField(noResultsLocator);


                $("select[multiple]").each(function () {

                    if (this.children.length < 5) {
                        $(this).css("width", "130%")
                            .attr("size", this.children.length);
                    }
                    else {
                        $(this).attr("size", 5);

                    }
                });


            } else {

                hideField(addressOptions);
                hideField(addressOptionsTitle);
                showField(noResultsLocator);
                uprnInput.val("");

            }

            showManualForm.off().on("click", function (evt) {
                evt.preventDefault();
                toggleManualEntryForm($(this));
                addressResults.hide();
            });
        };

        var showField = function (field) {
            field.removeClass("x");
            field.show();
        };

        var hideField = function (field) {
            field.addClass("x");
            field.hide();
        };

        var appendAddressFieldIfSet = function (field) {
            var value = '';

            if (field) {
                value = field + "<br />";
            }

            return value;
        };

        var toggleManualEntryForm = function (item) {
            var field = manualFormLocator,
                addressFinder = submitButton.closest(".m-addressFinder");
            addressFinder.addClass("is-manualAddress");
            if (field.hasClass("x")) {
                showManualEntryForm(field);

                item.parents("form").data('validator').resetForm();

                mando.resetFormValidation(item.parents("form"));

                hideField(addressOptions);
                hideField(addressOptionsTitle);
            } else {
                hideManualEntryForm(field);
            }
        };

        var showManualEntryForm = function () {
            var field = manualFormLocator;

            showField(field);

            mandatoryFields = field.find("input[data-val-required]");

            mandatoryFields.each(function () {
                var inpt = $(this);
                inpt.rules("add", {
                    required: true,
                    messages: {
                        required: inpt.data('val-required')
                    }
                });
            });

            manualPostcodeInput.val(postcodeInput.val());

            field.attr({
                'aria-expanded': 'true',
                'aria-selected': 'true',
                'aria-hidden': 'false'
            });
        };

        var hideManualEntryForm = function () {
            var field = manualFormLocator;

            hideField(field);
            field.attr({
                'aria-expanded': 'false',
                'aria-selected': 'false',
                'aria-hidden': 'true'
            });
        };

        _self.init = function () {
            if (submitButton[0]) {
                addEvents();

                if (!addressOptions.empty() && addressOptions.val() && addressOptions.val().length > 0) {
                    hideField(postcodeSearch);
                    hideField(manualFormLocator);
                }
            }
        };
    };
})(jQuery);

/*
 * To set manual address from fields as selector 
 * option on form submission
 */
$("form").on('submit', function () {
    $("[data-id=address-finder-manual-form]:visible").each(function () {
        _self = $(this),
            select = _self.siblings("[data-id=address-finder-results]")
                .find("select"),
            optionValue = {
                "Line1": null, "Line2": null, "Line3": null,
                "City": null, "Postcode": null, "RateableValue": 0, "Uprn": null, "IsSet": true
            },
            optionText = "",
            inputs = _self.find("input"),
            index = 0;

        for (var i in optionValue) {
            if (i == "Uprn")
                break;
            var fieldVal = inputs[index].value;
            if (i == "RateableValue" && fieldVal == "")
                fieldVal = 0;
            optionValue[i] = fieldVal;
            optionText += fieldVal + ',';
            ++index;
        }

        var option = new Option(optionText, JSON.stringify(optionValue));
        select.empty().
            append(option);
    });
});

function getTitleText(addressLength) {
    return addressLength > 1 ? 'Selected addresses' : 'Selected address'
}
